import * as React from 'react';

type Props = {
  width: number;
  relative?: boolean;
  children: React.ReactNode;
};

export const ClubProgrammeFilterControl = React.forwardRef<HTMLDivElement, Props>(
  ({ width, relative = false, children }, ref) => {
    return (
      <div ref={ref} style={{ width, position: relative ? 'relative' : undefined }}>
        {children}
      </div>
    );
  }
);

ClubProgrammeFilterControl.displayName = 'ClubProgrammeFilterControl';
